module.exports = __webpack_public_path__ + "./images/ba3f74e42fa1066ad8591d14d50cb53b.webp";